module.exports = __webpack_public_path__ + "img/ai-task-tagging.38238eed.svg";